export interface CodeItem {
  id: number
  groupName: string
  parentId?: number
  parentCode: string
  parentGroup: string
  code: string
  text: string
  description: string
  sortOrder: number
  Icon: string
}

export interface CodeResponse {
  Items: CodeItem[]
}

export interface GroupedCodeValues {
  [groupName: string]: CodeItem[]
}

export const CODE_VALUE_GROUPS = {
  LINE_OF_BUSINESS: "org.CodeLineOfBusiness",
  PROFILE_TYPE: "usr.CodeProfileType",
  CURRENCY: "geo.CodeCurrency",
  PROFILE_GROUP: "usr.CodeProfileGroup"
} as const
